import apiConfig from "../config";
import axios from "axios";

const getSuccessStories = async () => {
    try {
        const response = await axios.get(`${apiConfig.apiUrl}/SuccessStories`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching success stories:", error);
        return null;
    }
};

export { getSuccessStories };
